module.exports = __webpack_public_path__ + "img/PB_Slider_Image_Fail_920x520_M.d80f0e77.png";